var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3335 20V4H30.6668V20H25.3335ZM20.0002 4C20.7074 4 21.3857 4.28095 21.8858 4.78105C22.3859 5.28115 22.6668 5.95942 22.6668 6.66667V20C22.6668 20.7333 22.3735 21.4 21.8802 21.88L13.1068 30.6667L11.6935 29.2533C11.3335 28.8933 11.1068 28.4 11.1068 27.84L11.1468 27.4267L12.4135 21.3333H4.00016C3.29292 21.3333 2.61464 21.0524 2.11454 20.5523C1.61445 20.0522 1.3335 19.3739 1.3335 18.6667V16C1.3335 15.6533 1.40016 15.3333 1.52016 15.0267L5.54683 5.62667C5.94683 4.66667 6.8935 4 8.00016 4H20.0002ZM20.0002 6.66667H7.96016L4.00016 16V18.6667H15.7068L14.2002 25.76L20.0002 19.96V6.66667Z",
    fill: "#153C58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisLike);
export default __webpack_public_path__ + "static/media/DisLike.c909712bc987afabf3f5dddaaa1603d9.svg";
export { ForwardRef as ReactComponent };